// extracted by mini-css-extract-plugin
export default {"container":"preventive-maintenances_container__IUIsT","content":"preventive-maintenances_content__RYqKc"};